import {
  IconButton,
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
  SearchMdIcon,
} from '@crono-one/design-system';
import FormField from 'components/CreationForms/base/FormField';
import { useId } from 'react';

/** Shown under the field when the name is taken. */
export const COMPANY_NAME_TAKEN_ERROR =
  'A company with this name already exists';

export interface CompanyNameFieldProps {
  label: string;
  required?: boolean;
  /** The name belongs to a company already in Crono: the field says so. */
  isTaken: boolean;
  value: string;
  onChange: (value: string) => void;
  onSearchLinkedin: () => void;
}

/** The company name, with a LinkedIn search for it once something is typed. */
const CompanyNameField = ({
  label,
  required,
  isTaken,
  value,
  onChange,
  onSearchLinkedin,
}: CompanyNameFieldProps) => {
  const id = useId();
  const errorId = useId();

  return (
    <FormField label={label} required={required} fieldId={id}>
      <InputGroup dsSize="sm">
        <InputGroupInput
          id={id}
          placeholder="Type company name"
          aria-invalid={isTaken}
          aria-describedby={isTaken ? errorId : undefined}
          value={value}
          onChange={(event) => onChange(event.target.value)}
        />
        {!!value.trim() && (
          <InputGroupAddon align="inline-end">
            <IconButton
              variant="ghost"
              shape="rounded"
              size="xs"
              icon={SearchMdIcon}
              label="Search company on LinkedIn"
              onClick={onSearchLinkedin}
            />
          </InputGroupAddon>
        )}
      </InputGroup>
      {isTaken && (
        <p id={errorId} className="text-xs text-red-700">
          {COMPANY_NAME_TAKEN_ERROR}
        </p>
      )}
    </FormField>
  );
};

export default CompanyNameField;
